import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

function CasualLeave() {


  const value = 7;


  const remainingValue = 20 - value;

  const data = {
    labels: ['Completed', 'Remaining'],
    datasets: [{
      data: [value, remainingValue],
      backgroundColor: ['#9A258D', '#EDEFFE'],
    }],

  };

  const options = {
    cutout: '85%',
    padding: "0px",
    responsive: true,
    // maintainAspectRatio: true,
    width: "50",
    height: "50",

    plugins: {
      legend: {
        display: false,
      },
      tooltip: false,

    },
  };

  const textCenter = {
    // id:textCenter,
    beforeDatasetsDraw(chart,) {
      const { ctx, data } = chart;
      ctx.save();
      ctx.font = 'bolder 30px sans-serif'
      ctx.fillStyle = '#9A258D'
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(`${data.datasets[0].data[0]}`, chart.getDatasetMeta(0).data[0].x, chart.getDatasetMeta(0).data[0].y)
    }
  }




  return (
    <>


      <div  style={{ width: '120px', height: '100px' }}>
        <Doughnut data={data} options={options} plugins={[textCenter]} />
        <div>CasualLeave</div>
      </div>
    </>
  );
}

export default CasualLeave;
